<template>
	<div class="bigbox cursorstyleObjBtn">
		<div class="nav">
			当前位置：<span @click="userObj.routeClick('3')" class="navBoxTxt cursorstyleObjBtn"> 首页 </span> >
			<span  @click="userObj.routeClick('2')" class="navBoxTxt cursorstyleObjBtn">成果转化</span> >
			成果转化列表
		</div>
		<div  style="display: flex; margin-top: 5px" v-if="!this.$route.query.val">
			<div  @click="conversionBtn(0)">

        <el-button plain>待转化</el-button>
			</div>
			<div class="" @click="conversionBtn(1)">

        <el-button plain>已转化</el-button>
			</div>
		</div>
		<div class="bigitembox">
			<div class="itemtop">
				<div class="left">
					<img src="@/assets/chengguo/编组 15.png">
					转化
				</div>
			</div>
			<div class="" style="width: 100%;">
				<template>
					<el-table :data="tableData" style="width: 100%" @row-click="openDetails">
						<el-table-column type="index" label="序号" show-overflow-tooltip width="50" align="center">
						</el-table-column>
						<el-table-column prop="name" label="发明名称" show-overflow-tooltip align="center">
						</el-table-column>
						<el-table-column v-if="this.$route.query.val" prop="achievement_status_txt" label="状态"
							show-overflow-tooltip align="center">
						</el-table-column>
						<el-table-column prop="achievement_desc" label="所属地区" show-overflow-tooltip align="center">
						</el-table-column>
					</el-table>
				</template>
			</div>
		</div>

		<div class="" style="margin-top: 1vh; display: flex; justify-content: right;  margin-bottom: 2vh;">
			<div class="fenye">
				<!-- 分页 -->
				<el-pagination background :page-size="15" layout=" prev, pager, next" :total="this.total_count"
					:current-page="SubmitObj.page_num" @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		// 转化列表
		achievementList
	} from '@/api/Achievements.js'
	// 转化列表
	import {
		auditList
	} from "@/api/home.js"
	export default {
		data() {
			return {
				// 转化按钮
				conversionBtnVal: 0,
				tableData: [],
				// 总页数
				total_count: 50,
				SubmitObj: {
					page_num: null,
					page_size: 15
				},
				queryVal:''
			}
		},
		watch: {
		    $route: { // 亲测有效,我是用来监听query参数变化
		          handler() {
		              this.queryVal = this.$route.query.val;
		              this.achievementLists();
		              //深度监听，同时也可监听到param参数变化
		        },
		        deep: true,
		    }
		  },
		mounted() {
			if(this.$route.query.val){
				this.queryVal = this.$route.query.val
			}
			this.achievementLists()
		},
		methods: {
			// 跳转到详情页
			openDetails(row) {
				// {
				// 	path: './achievementDetail',
				// 	query: {
				// 		type: val.item.ip_type,
				// 		ids: val.item.id
				// 	}
				// }
				this.$router.push({
					path: './achievementDetail',
					query: {
						type: row.ip_type,
						ids: row.id
					}
				})
			},
			// 转化按钮
			conversionBtn(val) {
				this.conversionBtnVal = val
				this.achievementLists()
			},
			// 列表跳转
			handleCurrentChange(val) {
				this.SubmitObj.page_num = val
				this.achievementLists(1)
			},
			// 转化列表
			async achievementLists(val) {
				// let obj = {achievement_status:1,byok:1}
				let obj = {}
				if (this.$route.query.val) {
					if (val == 1) {
						obj = this.SubmitObj
						obj.name = this.queryVal
					}else{
						obj.name = this.queryVal
					}
				} else {
					if (val == 1) {
						obj = this.SubmitObj
						obj.achievement_status = this.conversionBtnVal
						obj.byok = 1
					} else {
						obj = {
							achievement_status: this.conversionBtnVal,
							byok: 1,
							page_size: 15
						}
					}
				}

				let res = await auditList(obj)
				if (res.code == '00000') {
					this.tableData = res.data.result
					this.total_count = res.data.total_count
				}

			},
		}
	}
</script>

<style scoped="scoped" lang="less">
	.bigbox {
		width: 63vw;
		margin: 0 auto;
		// border: 1px red solid;
	}

	.nav {
		margin-top: 14px;
		font-size: 1rem;
		color: #333333;
	}






	.bigitembox {
		width: 100%;
		height: calc(62.5vh + 29.5px);
		margin-right: 24px;
		margin-top: 1.8vh;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 3px rgba(0, 0, 0, 0.07);
		border-radius: 5px;
		overflow: hidden;
	}

	.itemtop {
		height: 3.6vh;
		width: 100%;
		// border: 1px red solid;
		display: flex;
		justify-content: space-between;
		line-height: 3.6vh;
		// text-align: center;

	}

	.itemtop .left {
		width: 7.6vw;
		background: url('~@/assets/chengguo/编组 12.png') no-repeat center;
		background-size: 100% 100%;
		color: #333333;
		font-size: 1rem;

		img {
			height: 54%;
			vertical-align: middle;
			margin-left: 3%;
			margin-right: 10%;
		}
	}

	.itemtop .right {
		margin-right: 3%;
		color: #333333;
		font-size: 0.87rem;
	}

	/deep/.el-table__header th {
		padding: 0;
		line-height: 3.6vh;
		height: 3.6vh;
		background: #F6FFF6;
		font-weight: bold;
		color: #666666;
		font-size: 0.88rem;

	}

	/deep/ .el-table__body td {
		padding: 0;
		height: 3.9vh;
		line-height: 3.9vh;
		color: #666666;
		font-size: 0.88rem;
	}

	/deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
		background-color: #005E3A;
		color: #FFFFFF;
	}
</style>
